module.exports = __webpack_public_path__ + "img/Villa_Borna_1.825a9310.jpg";